import { ArrowLeftOutlined, ShopOutlined } from '@ant-design/icons';
import { useIntl, useModel } from '@umijs/max';
import { Button } from 'antd';
import React from 'react';
import styles from './index.less';

/**
 * Banner shown when an Admin has entered a MerchantOwner's context via a
 * time-boxed access grant (same acting-as flow as SuperAdmin, but Admin-styled
 * wording). Parallel to ActingAsMerchantBanner (which is SuperAdmin-only).
 * The exit action clears the acting-as sessionStorage and returns to the
 * owner browse list at /merchants.
 */
const PartnerManagementBanner: React.FC = () => {
  const intl = useIntl();
  const { actingAsMerchantOwner, exitMerchantOwnerMode } =
    useModel('actingAsMerchant');

  if (!actingAsMerchantOwner) return null;

  const displayName =
    actingAsMerchantOwner.displayName || actingAsMerchantOwner.username;

  return (
    <div className={styles.banner}>
      <div className={styles.info}>
        <ShopOutlined />
        <span>
          {intl.formatMessage(
            {
              id: 'component.partnerManagement.label',
              defaultMessage: 'Managing: {name}',
            },
            { name: displayName },
          )}
        </span>
      </div>
      <Button
        className={styles.exitBtn}
        size="small"
        ghost
        icon={<ArrowLeftOutlined />}
        onClick={exitMerchantOwnerMode}
      >
        {intl.formatMessage({
          id: 'component.partnerManagement.exit',
          defaultMessage: 'Back to List',
        })}
      </Button>
    </div>
  );
};

export default PartnerManagementBanner;
